import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import Linkify from 'linkify-react';

import ImageApi from '../../../api/image';
import { TranslateApi } from '../../../api';
import PhoneIcon from '../../../assets/images/phone.svg';
import ContactIcon from '../../../assets/images/contact.svg';
import LocationIcon from '../../../assets/images/location.svg';

import CommunityDetailsItemHeader from '../componests/communityDetailsHeader';

const CommunityDetailsItem = ({ community, updateCommunity, addAlertToAlerts, currentUser }) => {
  const navigate = useNavigate();
  const [image, setImage] = useState('');
  const [isTranslated, setIsTranslated] = useState(false);
  const [title, setTitle] = useState(community.title);
  const [description, setDescription] = useState(community.description);
  const [location, setLocation] = useState(community.location);
  const [details, setDetails] = useState(community.details);
  

  useEffect(() => {
    if (community.image && community.image.url) {
      ImageApi.getImage(community.image.url).then((imageUrl) => {
        setImage(imageUrl);
      });
    }
  }, [community.id, community.image]);

  const onTranslateClicked = async() => {
    setIsTranslated(!isTranslated)
    let translatedTitle, translatedLocation, translatedDetails, translatedDescription;

    if (isTranslated) {
      setTitle(community.title);
      setDescription(community.description);
      setLocation(community.location);
      setDetails(community.details);

      return null
    }

    if (currentUser.language_id) {
      const resultTitle = await TranslateApi.getTranslation(currentUser.language_id, title)
      if (resultTitle && resultTitle.success) {
        translatedTitle = resultTitle.data
      }
  
      const resultLocation = await TranslateApi.getTranslation(currentUser.language_id, location)
      if (resultLocation && resultLocation.success) {
        translatedLocation = resultLocation.data
      }

      const resultDetails = await TranslateApi.getTranslation(currentUser.language_id, details)
      if (resultDetails && resultDetails.success) {
        translatedDetails = resultDetails.data
      }

      const resultDescription = await TranslateApi.getTranslation(currentUser.language_id, description)
      if (resultDescription && resultDescription.success) {
        translatedDescription = resultDescription.data
      }

    if (!translatedLocation || !translatedTitle || !translatedDetails || !translatedDescription) {
      addAlertToAlerts({
        title: 'Message',
        message: 'Translation to your selected language is not currently available.',
        confirmBtnText: 'Okay',
      });

      setIsTranslated(false)
    } else {
      setTitle(translatedTitle);
      setDescription(translatedDescription);
      setLocation(translatedLocation);
      setDetails(translatedDetails);
    }
    } else {
      addAlertToAlerts({
        title: 'Message',
        message: 'User does not have a language configured.',
        confirmBtnText: 'Okay',
      });
      setIsTranslated(false)
    }
  }

  return (
    <div className="community-container-inner">
      <CommunityDetailsItemHeader
        createdAt={community.created_at}
        author={community.author}
        communityId={community.id}
        goBack={() => navigate(-1)}
        updateCommunity={updateCommunity}
      />
      <div className="p-3">
        {image ? (
          <img className="community-container-image" src={image} alt="community-thumbnail" />
        ) : null}
        <p className="community-container-title mt-4">{title}</p>
        <p className="community-container-text mt-2 pb-5">{description}</p>
        {location ? (
          <>
            <div className="communitiy-container-contact">
              <img width="28" height="28" src={LocationIcon} alt="location icon" />
              <p className="community-container-text pl-3">{location}</p>
            </div>
            <div className="community-container-divider" />
          </>
        ) : null}
        {community.phone ? (
          <>
            <div className="communitiy-container-contact">
              <img width="28" height="28" src={PhoneIcon} alt="phone icon" />
              <p className="community-container-text pl-3">{community.phone}</p>
            </div>
            <div className="community-container-divider" />
          </>
        ) : null}

        {community.email_address ? (
          <>
            <div className="communitiy-container-contact">
              <img width="28" height="28" src={ContactIcon} alt="contact icon" />
              <a
                className="community-container-text community-container-text-decorator pl-3"
                href={`mailto:${community.email_address}`}
              >
                {community.email_address}{' '}
              </a>
            </div>
            <div className="community-container-divider" />
          </>
        ) : null}
      </div>

      <div className="p-3">
        <p className="community-container-title">Details</p>
        <Linkify
          options={{target: {
            url: '_blank'
          }}}
          className="community-container-text"
        >
          {details}
        </Linkify>
      </div>
      <div className="community-item-footer w-100 d-flex justify-content-end m-0 p-0 align-items-center" style={{cursor: 'pointer', right: 25, paddingTop: 20}} onClick={onTranslateClicked}>
        <p className="m-0 p-0 pr-2">{`${isTranslated ? "Show original" : "Translate this"}`}</p>
      </div>
    </div>
  );
};

export default CommunityDetailsItem;
